<template>
  <div class="line">
    <Header :present-page="presentPage" />
    <a-row class="top">
      <a-col class="ipt">
        <span>设备名称</span>
        <a-input
          v-model:value="searchData.deviceName"
          placeholder="请输入"
        />
        <!-- <a-select
          class="a-select"
          v-model:value="searchData.deviceName"
          placeholder="请选择"
        >
          <a-select-option
            :value="item.deviceName"
            v-for="(item, i) in deviceLists"
          >{{item.deviceName}}</a-select-option>
        </a-select> -->
        <a-divider type="vertical" />
      </a-col>
      <a-col class="ipt">
        <span>桥梁名称</span>
        <a-input
          v-model:value="searchData.bridgeName"
          placeholder="请输入"
        />
        <!-- <a-select
          class="a-select"
          v-model:value="searchData.bridgeName"
          placeholder="请选择"
        >
          <a-select-option
            :value="item.bridgeName"
            v-for="(item, i) in bridgeLists"
          >{{item.bridgeName}}</a-select-option>
        </a-select> -->
        <a-divider type="vertical" />
      </a-col>
      <a-col class="operate">
        <a-button
          type="primary"
          @click="search"
        >查询</a-button>
        <a-button
          type="default"
          @click="reset"
        >重置</a-button>
      </a-col>
      <a-col
        :span="2"
        :offset="6"
        class="add"
      >
        <a-button
          type="primary"
          @click="addModalShow"
        >
          + 新增
        </a-button>
      </a-col>
    </a-row>
    <a-table
      rowKey="deviceUuid"
      :pagination="pagination"
      :columns="columns"
      :data-source="dataSource"
      @change="change"
    >
      <!-- <template #iotThresholdItemVos="{text}">
        <template v-for="(item, i) in text">
          <p>{{item.parameterName}}&nbsp;&nbsp;一级:{{item.firstLevelThreshold}}&nbsp;&nbsp;二级:{{item.secondaryThreshold}}&nbsp;&nbsp;三级:{{item.tertiaryThreshold}}</p>
        </template>
      </template> -->
      <template #action="{record}">
        <a-button
          class="alter"
          @click="alterModalShow(record)"
        >修改</a-button>
        <a-button
          class="del"
          @click="delModalShow(record.deviceUuid)"
        >删除</a-button>
      </template>
    </a-table>
    <AddWarning
      ref="addWarning"
      :lineLists="lineLists"
      @confirm="init"
    />
    <AlterWarning
      ref="alterWarning"
      :lineLists="lineLists"
      :bridgeLists="bridgeLists"
      :deviceLists="deviceLists"
      :present="present"
      @confirm="init"
    />
    <DelModal
      ref="DelModal"
      @confirm="confirmDel"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header/header.vue";
import AddWarning from "@/components/earlyWarning/add.vue";
import AlterWarning from "@/components/earlyWarning/alter.vue";
import DelModal from "@/components/delModal.vue";
import { bridgeList, deviceList, lineList } from "@/api/project/project.js";
import { thresholdList, delThreshold } from "@/api/warning/warning.js";

export default {
  name: "EarlyWarning",
  components: {
    Header,
    AddWarning,
    AlterWarning,
    DelModal
  },
  data() {
    return {
      presentPage: '',
      searchData: {
        deviceName: '',
        bridgeName: '',
      },
      query: {
        pageNum: 1,
        pageSize: 10
      },
      delQuery: {
        uuid: ''
      },
      bridgeLists: [],
      deviceLists: [],
      lineLists: [],
      columns: [
        {
          title: '设备名称',
          dataIndex: 'deviceName',
        },
        {
          title: '线路名称',
          dataIndex: 'lineName',
        },
        {
          title: '桥梁名称',
          dataIndex: 'bridgeName',
        },
        // {
        //   title: '阈值',
        //   dataIndex: 'iotThresholdItemVos',
        //   slots: {
        //     customRender: 'iotThresholdItemVos',
        //   }
        // },
        {
          title: '阈值',
          dataIndex: 'yuzhi',
          ellipsis: true
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
        },
        {
          title: '操作',
          dataIndex: 'action',
          slots: {
            customRender: 'action',
          },
        },
      ],
      dataSource: [],
      pagination: {
        size: 'small',
        showSizeChanger: true,
        showQuickJumper: true,
        pageSize: 10,
        showTotal: total => `共 ${total} 条`,
        total: 0
      },
      measurements: [],
      present: '',
    }
  },
  mounted() {
    this.presentPage = this.$route.query.name
    this.init()
    bridgeList(this.query).then(res => { //桥梁列表
      if (res.code == 200) {
        this.bridgeLists = res.data.list
      }
    }).catch(res => {
      console.log(res)
    });
    deviceList(this.query).then(res => { //设备列表
      if (res.code == 200) {
        this.deviceLists = res.data.list
      }
    }).catch(res => {
      console.log(res)
    });
    lineList(this.query).then(res => { //线路列表
      if (res.code == 200) {
        this.lineLists = res.data.list
      }
    }).catch(res => {
      console.log(res)
    });
  },
  methods: {
    search() {
      this.query.filterDate = this.searchData
      this.init()
    },
    reset() {
      this.searchData.deviceName = ''
      this.searchData.bridgeName = ''
      this.search()
    },
    init() {
      thresholdList(this.query).then(res => { //阈值列表
        if (res.code == 200) {
          this.dataSource = res.data.list
          this.pagination.total = res.data.total
          for (let i = 0; i < this.dataSource.length; i++) {
            const el = this.dataSource[i];
            el.yuzhi = ''
            for (let j = 0; j < el.iotThresholdItemVos.length; j++) {
              const el2 = el.iotThresholdItemVos[j];
              if (el2.firstLevelThreshold || el2.secondaryThreshold || el2.tertiaryThreshold) {
                el.yuzhi += el2.parameterName + ' 一级: ' + el2.firstLevelThreshold + ' 二级: ' + el2.secondaryThreshold + ' 三级: ' + el2.tertiaryThreshold + '   '
              }
            }
          }
        }
      }).catch(res => {
        console.log(res)
      });
    },
    addModalShow() {
      this.$refs.addWarning.show();
    },
    alterModalShow(record) {
      this.present = record
      this.$refs.alterWarning.show();
    },
    delModalShow(id) {
      this.delQuery.uuid = id
      this.$refs.DelModal.show();
    },
    confirmDel() {
      delThreshold(this.delQuery).then(res => {
        if (res.code == 200) {
          this.init()
          this.$message.success(res.data);
        }
      }).catch(res => {
        console.log(res)
      });
    },
    change(pagination) {
      console.log(pagination)
      this.query = {
        pageNum: pagination.current,
        pageSize: pagination.pageSize
      }
      this.init()
    }
  }
};
</script>
<style scoped>
.top {
  height: 76px;
  margin: 20px 30px 0;
  padding: 20px 30px;
  line-height: 36px;
  background: #fff;
}

.ipt {
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: left;
}
.ipt span {
  margin-right: 10px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #222;
}
.ipt input {
  width: 236px;
  height: 36px;
  background: #fefefe;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.a-select :deep() .ant-select-selector {
  width: 236px;
  height: 40px;
  border-radius: 6px;
}
.a-select :deep() .ant-select-selection-item,
.a-select :deep() .ant-select-selection-placeholder {
  line-height: 38px !important;
}
.ant-divider-vertical {
  height: 22px;
  margin: 0 15px;
  background: #ddd;
}
.operate {
  text-align: left;
}
.operate button:nth-child(1) {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.operate button:nth-child(2) {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  background: #fff;
  border: 1px solid #bbbbbb;
  border-radius: 6px;
}
.add button {
  width: 80px;
  height: 36px;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
h4 {
  margin: 0 30px;
  padding-left: 16px;
  text-align: left;
  line-height: 2.4;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #0080ff;
  background: #fff;
}
.ant-table-wrapper {
  margin: 0 30px;
}
.ant-table-wrapper :deep() .ant-table-thead > tr > th,
.ant-table-wrapper :deep() .ant-table table {
  text-align: center;
}
.ant-table-wrapper .ant-btn {
  width: 66px;
  height: 24px;
  padding: 0;
  margin: 0 5px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  border-radius: 4px;
}
.alter {
  color: #0088ff;
  background: #fff;
  border: 1px solid #0088ff;
}
.del {
  color: #ff4444;
  background: #fff;
  border: 1px solid #ff4444;
}
</style>
